import { render, staticRenderFns } from "./SimilarListingsCheckboxFilter.vue?vue&type=template&id=128b1540&"
import script from "./SimilarListingsCheckboxFilter.vue?vue&type=script&lang=js&"
export * from "./SimilarListingsCheckboxFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports